import React from 'react';
import NoProductBlock from './NoProductBlock';
import ProductBlock from './ProductBlock';
import { ILoyaltyProductList } from '../../../../store/ducks/loyalty/types';

interface ProductListProps {
  productList: ILoyaltyProductList[];
  deleteProduct: (idx: number) => void;
  updateQty: (idx: number, qty: number) => void;
  updateQtyType: (idx: number, qty_type: string) => void;
}

const ProductList: React.FC<ProductListProps> = ({
  productList,
  deleteProduct,
  updateQty,
  updateQtyType
}) => {
  return (
    <div>
      {productList.length == 0 && <NoProductBlock />}
      {productList.length > 0 && (
        <ProductBlock
          productList={productList}
          deleteProduct={deleteProduct}
          updateQty={updateQty}
          updateQtyType={updateQtyType}
        ></ProductBlock>
      )}
    </div>
  );
};

export default ProductList;
